module.exports = "<footer class=\"kl-footer {class}\" r-style={ {height: height} }>\n    {#inc this.$body}\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/layout/KLLayout/KLFooter/index.html
// module id = 565
// module chunks = 0